import { IntegrationIconProps } from './types';

const Linux = ({ dimension }: IntegrationIconProps) => (
  <svg
    width={dimension || 32}
    height={dimension || 32}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M30 16C30 23.728 23.735 30 16 30C8.265 30 2 23.728 2 16C2 8.265 8.265 2 16 2C23.735 2 30 8.265 30 16Z"
      fill="white"
    />
    <path
      d="M11.3063 21.91C11.181 21.7232 11.0714 21.4713 10.9824 21.1699C9.37571 19.358 10.6169 16.6916 11.8446 14.881C11.9623 14.6874 12.0905 14.5004 12.2299 14.3215C13.1666 13.1577 13.4089 12.3478 13.481 11.2521C13.4896 11.0481 13.4727 10.7781 13.4533 10.4678C13.3542 8.8837 13.1895 6.25174 16.0159 6.0184C19.5489 5.72669 19.2611 8.97105 19.235 10.8732C19.2339 10.9519 19.2328 11.0285 19.2321 11.1024C19.2225 12.249 19.8209 13.0341 20.4455 13.8535C20.6736 14.1528 20.9052 14.4566 21.112 14.7843C21.1181 14.794 21.1242 14.8038 21.1303 14.8135C22.2218 16.3877 23.2994 18.737 21.7995 20.9653C21.5887 21.7259 21.2695 22.424 20.8434 22.9921C19.3136 25.0052 17.9539 24.8008 16.892 24.6412C16.5717 24.5931 16.2785 24.549 16.0159 24.5711C15.5797 24.5977 15.2301 24.6682 14.9281 24.7292C13.7608 24.9648 13.3046 25.0569 11.3063 21.91Z"
      fill="black"
    />
    <path
      d="M18.0139 7.79476C17.9811 8.72716 16.9921 9.53705 15.8065 9.61192C14.6209 9.68678 13.6907 8.97897 13.7235 8.04658C13.7562 7.11418 14.7453 6.30428 15.9309 6.22942C17.1165 6.16136 18.0466 6.86236 18.0139 7.79476Z"
      fill="url(#paint0_linear_1334_916)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.8656 10.0611C15.8751 10.5682 16.1073 11.0005 16.4334 11.1957C15.3695 11.1004 14.0512 11.4894 14.0512 12.2254C14.0348 13.4706 13.3418 15.0198 12.8429 16.1349C12.7447 16.3545 12.654 16.5573 12.5774 16.7377C12.2686 17.5024 12.0833 18.3202 12.0614 19.1224C11.2435 17.995 11.8378 16.5487 12.1582 15.921C12.5846 15.0949 12.5764 14.9918 12.4108 15.1854C11.7759 16.265 10.5803 18.4335 12.0775 19.7362C12.125 20.3179 12.2667 20.8816 12.5185 21.3997C14.5228 25.4423 18.2761 23.7817 19.5141 21.6855C19.6788 21.3875 19.812 21.0991 19.9177 20.8205C19.9797 20.8596 20.0461 20.8898 20.1167 20.9096C20.739 21.0934 21.6691 20.3924 21.8918 19.9568C22.1604 19.3783 21.8853 18.9836 20.9683 18.514C20.9215 18.4908 20.8753 18.4691 20.8297 18.4488C21.1814 16.9678 20.2122 15.4278 19.52 14.7745C19.3909 14.7427 19.3727 14.8159 19.5731 15.0158C20.009 15.4335 20.9572 16.9231 20.4442 18.3093C20.3597 18.2866 20.2784 18.2707 20.2009 18.2619C20.0433 17.3161 19.6231 16.5802 19.3294 16.0661C19.2629 15.9496 19.2029 15.8444 19.1538 15.7508C19.055 15.562 18.9368 15.3664 18.8114 15.159C18.3283 14.3597 17.739 13.3845 17.739 11.9396C17.6651 11.6216 17.3651 11.4097 16.9658 11.2926C17.4293 11.1991 17.7772 10.6576 17.7652 10.0067C17.7521 9.3057 17.3132 8.74762 16.7892 8.76123C16.2652 8.77484 15.846 9.36014 15.8656 10.0611ZM16.2979 10.2177C16.2914 10.6056 16.4748 10.9187 16.7172 10.9187C16.953 10.9187 17.156 10.6056 17.1626 10.2245C17.1691 9.83655 16.9857 9.52349 16.7434 9.52349C16.501 9.52349 16.3045 9.83655 16.2979 10.2177Z"
      fill="url(#paint1_linear_1334_916)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.5556 11.1501C14.9355 11.1297 15.2106 10.6192 15.1779 10.0135C15.1451 9.40778 14.8111 8.93818 14.4311 8.9586C14.0512 8.97902 13.7761 9.48945 13.8089 10.0952C13.8416 10.7009 14.1757 11.1705 14.5556 11.1501ZM14.7848 10.2245C14.8176 10.5444 14.6997 10.8166 14.5294 10.8438C14.3591 10.8642 14.1953 10.626 14.1626 10.3062C14.1298 9.98628 14.2477 9.71405 14.418 9.68682C14.5883 9.6664 14.7521 9.90461 14.7848 10.2245Z"
      fill="url(#paint2_linear_1334_916)"
    />
    <path
      d="M16.397 9.99987C16.3774 10.2177 16.4756 10.3946 16.6132 10.4082C16.7507 10.4218 16.8818 10.2517 16.9014 10.0407C16.9211 9.82292 16.8228 9.64597 16.6852 9.63236C16.5477 9.61874 16.4167 9.78889 16.397 9.99987Z"
      fill="url(#paint3_linear_1334_916)"
    />
    <path
      d="M14.641 10.0542C14.6606 10.2312 14.5886 10.3877 14.4838 10.4013C14.379 10.4149 14.2807 10.2788 14.261 10.0951C14.2414 9.91811 14.3134 9.76158 14.4183 9.74797C14.5231 9.73436 14.6213 9.87728 14.641 10.0542Z"
      fill="url(#paint4_linear_1334_916)"
    />
    <path
      d="M18.67 17.1528C18.67 18.3506 17.563 19.9023 15.6634 19.8887C13.7049 19.9023 12.873 18.3506 12.873 17.1528C12.873 15.9549 14.17 14.9817 15.7682 14.9817C17.373 14.9885 18.67 15.9549 18.67 17.1528Z"
      fill="url(#paint5_linear_1334_916)"
    />
    <path
      d="M17.6336 13.3892C17.614 14.6279 16.8345 14.9205 15.852 14.9205C14.8694 14.9205 14.1555 14.7367 14.0703 13.3892C14.0703 12.5453 14.8694 12.0552 15.852 12.0552C16.8345 12.0484 17.6336 12.5385 17.6336 13.3892Z"
      fill="url(#paint6_linear_1334_916)"
    />
    <path
      d="M11.6927 15.2947C12.3346 14.2807 13.6905 12.7221 11.9481 15.5125C10.5333 17.8129 11.4241 19.2898 11.8826 19.6981C13.2058 20.9232 13.1534 21.7467 12.1119 21.1001C9.87824 19.7185 10.3433 17.3909 11.6927 15.2947Z"
      fill="url(#paint7_linear_1334_916)"
    />
    <path
      d="M20.9881 15.71C20.4314 14.519 18.6628 11.4972 21.0733 15.009C23.2676 18.1873 21.7283 20.3992 21.4532 20.617C21.1781 20.8348 20.2545 21.2771 20.5231 20.5081C20.7982 19.739 22.1606 18.2826 20.9881 15.71Z"
      fill="url(#paint8_linear_1334_916)"
    />
    <path
      d="M11.2079 25.1019C9.74067 24.2921 7.61185 25.2585 8.38477 23.067C8.54198 22.5702 8.15552 21.8215 8.40442 21.3383C8.69918 20.7462 9.33456 20.8755 9.71447 20.4808C10.0878 20.0724 10.3236 19.3646 11.0245 19.4735C11.7188 19.5824 12.1839 20.4672 12.6686 21.5561C13.0289 22.332 14.2996 23.4277 14.2145 24.2989C14.1097 25.6328 12.649 25.8846 11.2079 25.1019Z"
      fill="url(#paint9_linear_1334_916)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.87664 20.6403C9.51984 21.0305 8.86452 20.937 8.60152 21.4476C8.43261 21.7755 8.61716 22.2795 8.64206 22.6386C8.67282 23.0822 8.30503 23.7109 8.49233 24.0898C8.70268 24.5153 9.65296 24.4601 10.0707 24.5211C11.1019 24.6718 12.8063 26.0064 13.7388 24.9413C14.6504 23.9 12.8982 22.5824 12.4684 21.6567C12.1889 21.0288 11.7706 19.8248 10.992 19.7026C10.4431 19.6174 10.1931 20.2942 9.87664 20.6403ZM11.0583 19.2445C12.0278 19.3965 12.5129 20.6534 12.8707 21.4571C13.4138 22.6226 15.2747 23.8753 14.0686 25.253C12.9732 26.5042 11.2438 25.1603 10.0086 24.9798C9.39166 24.8897 8.41858 24.9544 8.09576 24.3014C7.81821 23.7399 8.2362 23.2314 8.1974 22.6719C8.16434 22.1951 7.97565 21.6831 8.2077 21.2305C8.52537 20.5943 9.13864 20.7484 9.55546 20.319C9.99809 19.8327 10.2634 19.121 11.0583 19.2445Z"
      fill="#E68C3F"
    />
    <path
      d="M21.3814 24.7276C22.4556 23.3732 24.8464 23.6523 23.2351 21.7943C22.8945 21.3927 22.9993 20.5352 22.5801 20.1677C22.0888 19.7185 21.5451 20.086 21.0473 19.8546C20.5495 19.6028 20.0255 19.1196 19.4163 19.4599C18.8071 19.807 18.7416 20.7053 18.6827 21.8895C18.6303 22.7403 17.8836 24.1627 18.2831 24.9454C18.8596 26.1568 20.3596 25.9935 21.3814 24.7276Z"
      fill="url(#paint10_linear_1334_916)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.8097 19.6979C22.0851 19.6907 22.415 19.71 22.7248 19.9922C23.1101 20.3319 23.1139 20.8865 23.2592 21.3508C23.4312 21.9006 24.0341 22.2147 23.998 22.8594C23.9391 23.9134 22.1138 24.1673 21.552 24.8757C21.0121 25.5444 20.3297 25.9427 19.6821 25.9964C18.7 26.0778 17.8888 25.2519 17.9462 24.2436C17.9928 23.4274 18.4086 22.6858 18.4593 21.8761C18.4885 21.2898 18.52 20.7461 18.626 20.3047C18.7331 19.8587 18.9261 19.4745 19.3083 19.2568C20.1453 18.7892 20.9539 19.7203 21.8097 19.6979ZM19.5219 19.6634C19.2953 19.7929 19.1512 20.0314 19.0586 20.4169C18.9649 20.8071 18.9341 21.307 18.9043 21.9043C18.8543 22.716 18.4377 23.457 18.3913 24.271C18.3499 24.997 18.9075 25.5958 19.6467 25.5346C20.1484 25.493 20.7272 25.1761 21.2091 24.5795C21.6397 24.0371 23.5137 23.5334 23.5529 22.8325C23.5785 22.3749 22.9765 21.9456 22.8351 21.494C22.7245 21.1405 22.7187 20.593 22.4355 20.3447C22.2545 20.1793 22.0641 20.1546 21.8209 20.161C21.1162 20.1795 20.1761 19.2989 19.5219 19.6634Z"
      fill="#E68C3F"
    />
    <path
      d="M20.9156 22.9173C22.5793 20.3651 21.3413 20.3855 20.9221 20.1881C20.5029 19.9839 20.0641 19.5824 19.5728 19.8614C19.0815 20.1473 19.0553 20.8823 19.0422 21.8487C19.0226 22.5429 18.4658 23.7067 18.7999 24.3533C19.206 25.1087 20.1885 24.013 20.9156 22.9173Z"
      fill="url(#paint11_linear_1334_916)"
    />
    <path
      d="M10.8682 23.2848C8.37909 21.6106 9.54502 21.0389 9.91839 20.7735C10.3704 20.4332 10.3769 19.7798 10.9337 19.8411C11.4904 19.9023 11.8179 20.6169 12.1913 21.5017C12.4664 22.1346 13.4228 22.9785 13.3507 23.7068C13.259 24.5643 11.9424 23.9994 10.8682 23.2848Z"
      fill="url(#paint12_linear_1334_916)"
    />
    <path
      d="M21.7472 19.9364C21.5506 20.2903 20.7515 20.8484 20.221 20.6987C19.6773 20.5557 19.4284 19.7594 19.5397 19.1605C19.638 18.48 20.221 18.4459 20.9546 18.7862C21.7341 19.1537 21.9764 19.4668 21.7472 19.9364Z"
      fill="black"
    />
    <path
      d="M21.2108 19.7389C21.0863 19.9839 20.5623 20.3718 20.1955 20.2697C19.8287 20.1676 19.6453 19.6164 19.7042 19.2012C19.7566 18.7316 20.1496 18.7044 20.6475 18.9358C21.1846 19.1944 21.3549 19.4122 21.2108 19.7389Z"
      fill="url(#paint13_linear_1334_916)"
    />
    <path
      d="M14.4374 10.8573C14.6994 10.6055 15.3348 9.83644 16.54 10.6395C16.7627 10.7893 16.9461 10.8029 17.3719 10.9934C18.23 11.3609 17.8238 12.2457 16.9068 12.5452C16.5138 12.6745 16.1601 13.1713 15.4527 13.1237C14.8435 13.0896 14.6863 12.6745 14.3129 12.4499C13.6514 12.0619 13.5531 11.5379 13.9134 11.2589C14.2736 10.9798 14.4112 10.8777 14.4374 10.8573Z"
      fill="url(#paint14_linear_1334_916)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.9933 11.3703C13.8563 11.4764 13.8127 11.6174 13.858 11.7734C13.951 12.0938 14.6216 12.5345 14.8784 12.7501C15.0244 12.8727 15.1914 12.9699 15.4613 12.985C16.0393 13.0239 16.3603 12.5792 16.8667 12.4126C17.1997 12.3038 17.9044 11.8882 17.671 11.4119C17.4718 11.0054 16.8008 10.9803 16.4675 10.7563C15.8939 10.3742 15.4763 10.3769 15.1788 10.4841C14.8528 10.6016 14.2885 11.1416 13.9933 11.3703ZM15.0911 10.2215C15.4781 10.0821 15.9812 10.1021 16.6126 10.5228C17.0276 10.8018 17.659 10.7749 17.9093 11.2858C18.2282 11.9365 17.4555 12.5116 16.947 12.6777C16.4025 12.857 16.0983 13.3061 15.4447 13.2624C15.1058 13.2433 14.8884 13.1158 14.7103 12.9663C14.3408 12.6561 13.7165 12.3613 13.5738 11.8694C13.4946 11.5966 13.6101 11.3204 13.8334 11.1474C14.1943 10.8679 14.682 10.369 15.0911 10.2215Z"
      fill="#E68C3F"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.4735 11.5668C17.4762 11.6179 17.4385 11.6616 17.3894 11.6644C16.6961 11.7037 16.2089 12.4948 15.426 12.4948C14.9879 12.4948 14.6411 12.2835 14.3932 12.0802C14.3432 12.0392 13.9023 11.6993 13.9023 11.6127C13.9023 11.5616 13.9423 11.5201 13.9915 11.5201C14.0836 11.5201 14.3616 11.8217 14.465 11.9065C14.6985 12.0979 15.0453 12.3096 15.426 12.3096C16.2011 12.3096 16.6766 11.5192 17.3797 11.4794C17.4288 11.4766 17.4709 11.5158 17.4735 11.5668Z"
      fill="#E68C3F"
    />
    <path
      d="M14.8442 10.7893C14.9752 10.6668 15.3878 10.3333 15.9315 10.6736C16.0494 10.7416 16.1673 10.8165 16.3376 10.9186C16.6848 11.1296 16.5145 11.4358 16.0952 11.6264C15.9053 11.7081 15.5909 11.885 15.3551 11.8714C15.0931 11.8442 14.9162 11.6672 14.7459 11.5515C14.4249 11.3338 14.4446 11.15 14.5952 11.0071C14.7066 10.8982 14.8311 10.7961 14.8442 10.7893Z"
      fill="url(#paint15_linear_1334_916)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1334_916"
        x1="16.0578"
        y1="6.30641"
        x2="15.8364"
        y2="9.30623"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0.8" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1334_916"
        x1="12.8966"
        y1="22.6724"
        x2="11.2506"
        y2="17.2718"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFEED7" />
        <stop offset="1" stopColor="#BDBFC2" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1334_916"
        x1="12.8966"
        y1="22.6724"
        x2="11.2506"
        y2="17.2718"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFEED7" />
        <stop offset="1" stopColor="#BDBFC2" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_1334_916"
        x1="16.6691"
        y1="9.6557"
        x2="16.5758"
        y2="10.3545"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0.65" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_1334_916"
        x1="14.434"
        y1="9.78294"
        x2="14.5344"
        y2="10.3483"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0.65" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_1334_916"
        x1="15.7623"
        y1="15.6308"
        x2="15.7789"
        y2="19.6274"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0.8" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_1334_916"
        x1="15.8494"
        y1="13.1247"
        x2="15.8678"
        y2="14.7138"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0.65" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_1334_916"
        x1="11.719"
        y1="14.1055"
        x2="11.719"
        y2="19.9372"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0.65" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_1334_916"
        x1="21.033"
        y1="13.5359"
        x2="21.0308"
        y2="18.8052"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0.65" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_1334_916"
        x1="11.4276"
        y1="22.4373"
        x2="10.5344"
        y2="25.4213"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFA63F" />
        <stop offset="1" stopColor="#FFFF00" />
      </linearGradient>
      <linearGradient
        id="paint10_linear_1334_916"
        x1="19.882"
        y1="21.5297"
        x2="22.2656"
        y2="24.7799"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFA63F" />
        <stop offset="1" stopColor="#FFFF00" />
      </linearGradient>
      <linearGradient
        id="paint11_linear_1334_916"
        x1="20.5198"
        y1="18.9332"
        x2="19.6863"
        y2="22.8604"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0.65" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint12_linear_1334_916"
        x1="11.2464"
        y1="19.9044"
        x2="11.4117"
        y2="24.3241"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0.65" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint13_linear_1334_916"
        x1="20.3755"
        y1="18.8616"
        x2="20.5688"
        y2="20.1822"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0.65" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint14_linear_1334_916"
        x1="15.7644"
        y1="10.7837"
        x2="15.7805"
        y2="13.1095"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFA63F" />
        <stop offset="1" stopColor="#FFFF00" />
      </linearGradient>
      <linearGradient
        id="paint15_linear_1334_916"
        x1="15.5106"
        y1="10.5638"
        x2="15.5062"
        y2="11.7936"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0.65" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
);
export default Linux;
